import { render, staticRenderFns } from "./ClientFullDataView.vue?vue&type=template&id=03dd7021&scoped=true"
import script from "./ClientFullDataView.vue?vue&type=script&lang=js"
export * from "./ClientFullDataView.vue?vue&type=script&lang=js"
import style0 from "./ClientFullDataView.vue?vue&type=style&index=0&id=03dd7021&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03dd7021",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
